import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.$element.on("hidden.bs.modal.induction", function() {
      this.remove();
    });
  }

  disconnect() {
    this.$element.off("hidden.bs.modal.induction");
  }

  get $element() {
    return $(this.element);
  }
}
